import React from 'react'
import { getConfig } from '../config/gameConfig';
import publisherlogo from "../assets/publisher-logo.png";
import gamelogo from "../assets/game-logo.png";
import { useLanguage } from '../contexts/LanguageContext';
import { trackProgress } from '../utils/progressApi';

export const Earned = ({ earned, setEarned, setUserName, userName, setStop, setQuestionNumber, setShowCredits, setQuestionSet, setFiftyUsed, setChangeUsed, isFirstError, setIsFirstError, gameCompleted, setGameCompleted, questionNumber, onShowComplete, wasError, chancesUsed, setChancesUsed, handlePlayAgain, questionSetName, totalQuestions }) => {
    const { language } = useLanguage();

    const lastCorrectAnswer = questionNumber - 1;
    const secondChances = getConfig('secondChances');
    const hasChancesLeft = chancesUsed < secondChances;

    // Check if user completed all questions
    const completedAllQuestions = lastCorrectAnswer === 10;

    const handleClick = async () => {
        if (completedAllQuestions) {
            // User answered all questions correctly, show Complete screen
            if (onShowComplete) {
                onShowComplete();
            } else {
                setGameCompleted && setGameCompleted(true);
            }
        } else if (hasChancesLeft && secondChances > 0) {
            // User has chances left, continue game
            setStop(false);
            setChancesUsed(prev => prev + 1);
            setFiftyUsed && setFiftyUsed(false); // Reset 50-50 effect for retry
            // Do not reset lifelines, user continues
        } else {
            // No chances left, game over - track failure before restart
            if (getConfig('debugMode')) {
                console.log('💀 User failed - no chances left, tracking failure...');
            }
            
            try {
                await trackProgress({
                    username: userName,
                    questionset: questionSetName,
                    action: 'fail',
                    notes: `Απέτυχε στην ερώτηση ${questionNumber}. Απάντησε σωστά ${lastCorrectAnswer} από ${totalQuestions} ερωτήσεις.`
                });
                
                if (getConfig('debugMode')) {
                    console.log('✅ Failure tracked successfully');
                }
            } catch (error) {
                console.error('❌ Failed to track failure:', error);
            }
            
            handlePlayAgain();
        }
    };

    return (
        <div className="start">
            <div className="logo-bar">
                <img src={publisherlogo} alt={language.altText.publisherLogo} className="logo-left" />
                <img src={gamelogo} alt={language.altText.gameLogo} className="logo-right" />
            </div>
            <div className="content">
                <div className="dialog">
                    {completedAllQuestions ? (
                        <>
                            {/* User completed all questions - this shouldn't typically show here */}
                            <h1 className='endText'>{language.complete.congratulations}</h1>
                            <button onClick={handleClick} className='main-btn'>{language.earned.continueButton}</button>
                        </>
                    ) : hasChancesLeft && secondChances > 0 ? (
                        <>
                            {/* User has chances left */}
                            <h1 className='endText'>{language.earned.withChancesLine1}</h1>
                            <h1 className='endText'>{language.earned.withChancesLine2}</h1>
                            <h3 className='endText'>{language.earned.withChancesLine3}</h3>
                            <button onClick={handleClick} className='main-btn'>{language.earned.continueButton}</button>
                        </>
                    ) : (
                        <>
                            {/* No chances left - game over */}
                            <h1 className='endText'>{language.earned.noChancesLine1}</h1>
                            <h1 className='endText'>{language.earned.noChancesLine2}</h1>
                            <h3 className='endText'>{language.earned.noChancesLine3}</h3>
                            <button onClick={handleClick} className='main-btn'>{language.earned.playAgainButton}</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
